import React, { type ReactNode } from "react";
import { Link } from "ui/link";
import Image from "next/image";
import { type Icon } from "components/footer/data";

type NavItemProps = {
  color?: string;
  children: ReactNode;
  href?: string;
  icon?: Icon;
  onClick?: () => void;
};

export function NavItem({ color, href, children, icon, onClick }: NavItemProps) {
  return (
    <Link color={color} variant="footer" href={href} onClick={onClick}>
      {children}
      {icon && <Image src={icon.src} alt={icon.alt} width={24} height={24} />}
    </Link>
  );
}
